import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import moment from 'moment';

import Select from 'react-select';
import { Col, Row } from 'react-bootstrap';
import {
  Layout,
  Title,
  ItemLabel,
  ReceiptInputGroup,
  ReceiptInput,
  SuffixText,
  ReceiptButton,
  ReceiptButtonSpinner,
  ReceiptErrorMessage,
  ReceiptErrorMessageText,
  Explanation,
} from './Receipt.style';
import MyPageLayout from '../../components/Layouts/MyPage/MyPageLayout.index';

import { RootState } from '../../store/reducers';
import {
  GET_RECEIPT_DATA_INITIAL,
  GET_RECEIPT_DATA_REQUEST,
  GET_RECEIPT_INITIAL,
  GET_RECEIPT_REQUEST,
  UPDATE_RECEIPT_INITIAL,
  UPDATE_RECEIPT_REQUEST,
} from '../../store/actions';
import { GetReceiptDataStateType } from '../../store/reducers/receipt/getReceiptDataReducer';
import { GetReceiptStateType } from '../../store/reducers/receipt/getReceiptReducer';
import { UpdateReceiptStateType } from '../../store/reducers/receipt/updateReceiptReducer';

import useAuthorizationNormal from '../../hooks/Auth/useAuthorizationNormal';

import FW from '../../config/word.json';
import FS from '../../config/sentence.json';

import { getStrLength } from '../../utils/getStrLength';
// import { isAppleButNotMac } from '../../utils/uaHandle';

import './Receipt.css';

interface selectInfo {
  value: string;
  label: string;
  isSelected: boolean;
}

/**
 * 領収書画面
 */
const Receipt: FC = () => {
  // ライブラリーを変数に設定する
  const dispatch = useDispatch();
  // const location = useLocation();
  const history = useHistory();

  const { isGetReceiptDataLoaded, getReceiptData } = useSelector<RootState, GetReceiptDataStateType>(
    (state) => state.receipt.getReceiptData,
  );
  const targetMonthOptionList: selectInfo[] = [];
  let defaultTargetMonthIndex = -1;
  // let targetMonthSelectValue: selectInfo | null = null;
  const [targetMonthSelectValue, setTargetMonthSelectValue] = useState<selectInfo | null>(null);
  const [getTargetMonth, setTargetMonth] = useState(0);
  const paymentDateOptionList: selectInfo[] = [];
  let defaultPaymentDateIndex = -1;
  // let paymentDateSelectValue: selectInfo | null = null;
  const [paymentDateSelectValue, setPaymentDateSelectValue] = useState<selectInfo | null>(null);
  const [getPaymentDate, setPaymentDate] = useState('');

  const { isGetReceiptLoaded, getReceipt } = useSelector<RootState, GetReceiptStateType>(
    (state) => state.receipt.getReceipt,
  );

  const [recipientName, setRecipientName] = useState('');
  const [clauseTitle, setClauseTitle] = useState('');

  const { isUpdateReceiptLoading, isUpdateReceiptLoaded, updateReceipt } = useSelector<
    RootState,
    UpdateReceiptStateType
  >((state) => state.receipt.updateReceipt);

  const [isDisableRecipientName, setIsDisableRecipientName] = useState(false);
  // const [downloadWindow, setDownloadWindow] = useState<Window | null>(null);

  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    return () => {
      dispatch({
        type: GET_RECEIPT_DATA_INITIAL,
      });
      dispatch({
        type: GET_RECEIPT_INITIAL,
      });
      dispatch({
        type: UPDATE_RECEIPT_INITIAL,
      });
    };
  }, []);

  // ログイン認証を設定する
  useAuthorizationNormal();

  /**
   * 画面描画時の処理
   * 請求情報取得API呼び出す
   */
  useEffect(() => {
    const memberID = sessionStorage.getItem('memberID') ?? '';
    dispatch({
      type: GET_RECEIPT_DATA_REQUEST,
      memberId: memberID,
      history,
    });
  }, []);

  if (isGetReceiptDataLoaded) {
    if (getReceiptData.targetMonthList) {
      let index = -1;
      for (let i = 0; i < getReceiptData.targetMonthList.length; i += 1) {
        targetMonthOptionList.push({
          label: moment(getReceiptData.targetMonthList[i], 'YYYYMM').format('YYYY/MM'),
          value: getReceiptData.targetMonthList[i].toString(),
          isSelected: false,
        });

        if (moment(getReceiptData.targetMonthList[i], 'YYYYMM').isSame(moment(), 'month')) {
          index = i;
        }
      }

      if (index < 0) {
        index = 0;
      }
      defaultTargetMonthIndex = index;
    }
  }

  useEffect(() => {
    if (defaultTargetMonthIndex >= 0) {
      setTargetMonth(parseInt(targetMonthOptionList[defaultTargetMonthIndex].value, 10));
      setTargetMonthSelectValue(targetMonthOptionList[defaultTargetMonthIndex]);
    }
  }, [isGetReceiptDataLoaded, defaultTargetMonthIndex]);

  const targetMonthSelectChange = (e: any): void => {
    setTargetMonth(parseInt(e.value, 10));
    // targetMonthSelectValue = e;
    setTargetMonthSelectValue(e);
  };

  if (isGetReceiptDataLoaded) {
    if (getTargetMonth) {
      const targetMonthList = getReceiptData.targetMonthDataMap?.[getTargetMonth];
      if (targetMonthList) {
        for (let i = 0; i < targetMonthList.length; i += 1) {
          const dateF = moment(targetMonthList[i].slice(0, 8), 'YYYYMMDD').format('YYYY/MM/DD');
          const label = dateF + targetMonthList[i].slice(8);

          paymentDateOptionList.push({
            label,
            value: targetMonthList[i],
            isSelected: false,
          });
        }

        defaultPaymentDateIndex = 0;
      }
    }
  }

  useEffect(() => {
    if (defaultPaymentDateIndex >= 0) {
      setPaymentDate(paymentDateOptionList[defaultPaymentDateIndex].value);
      setPaymentDateSelectValue(paymentDateOptionList[defaultPaymentDateIndex]);
    }
  }, [isGetReceiptDataLoaded, defaultPaymentDateIndex, getTargetMonth]);

  const paymentDateSelectChange = (e: any): void => {
    setPaymentDate(e.value);
    // paymentDateSelectValue = e;
    setPaymentDateSelectValue(e);
  };

  useEffect(() => {
    if (isGetReceiptDataLoaded && getTargetMonth && getPaymentDate) {
      const memberID = sessionStorage.getItem('memberID') ?? '';
      dispatch({
        type: GET_RECEIPT_REQUEST,
        memberId: memberID,
        targetMonth: getTargetMonth,
        paymentDate: getPaymentDate,
        history,
      });
    }
    // }, [isGetReceiptDataLoaded, getTargetMonth, getPaymentDate]);
  }, [isGetReceiptDataLoaded, getPaymentDate]);

  useEffect(() => {
    if (isGetReceiptLoaded) {
      // if (getReceipt.result > 0) {
      //   setRecipientName(getReceipt.recipientName || '');
      //   setClauseTitle(getReceipt.clauseTitle || '');
      // } else {
      //   setRecipientName('スポーツジム利用料');
      // }
      setRecipientName(getReceipt.recipientName || '');
      setClauseTitle(getReceipt.clauseTitle || '');
    }
  }, [isGetReceiptLoaded]);

  const onChangeRecipientName = (eve: React.ChangeEvent<HTMLInputElement>) => {
    setRecipientName(eve.target.value);
  };

  const onChangeClauseTitle = (eve: React.ChangeEvent<HTMLInputElement>) => {
    setClauseTitle(eve.target.value);
  };

  // useEffect(() => {
  //     setRecipientName('');
  //     setClauseTitle('');
  //     setIsOnChangeButtonControl(true);
  //     setErrorMessage('');
  // }, []);

  const onClickReceiptConfirm = () => {
    setErrorMessage('');

    if (isGetReceiptDataLoaded && getTargetMonth && getPaymentDate && recipientName) {
      if (!recipientName.trim()) {
        setErrorMessage('宛先名は入力必須項目です。');
        return;
      }
      if (getStrLength(recipientName) > 36) {
        setErrorMessage('宛先名は全角18文字（半角36文字）以内で入力ください。');
        return;
      }
      if (clauseTitle && getStrLength(clauseTitle) > 64) {
        setErrorMessage('但書名は全角32文字（半角50文字）以内で入力ください。');
        return;
      }

      // console.log('navigator.platform ', navigator.platform);
      // console.log('navigator.userAgent ', navigator.userAgent);
      // console.log('navigator.maxTouchPoints ', navigator.maxTouchPoints);
      // alert(
      //   `platform: ${navigator.platform} userAgent: ${navigator.userAgent} maxTouchPoints: ${navigator.maxTouchPoints}`,
      // );
      // if (isAppleButNotMac()) {
      //   const win = window.open('', '_blank');
      //   setDownloadWindow(win);
      //   win?.document.write(`
      //     <html>
      //       <head>
      //         <meta charset="SHIFT_JIS">
      //       </head>
      //       <body>
      //         <p>ダウンロードの準備をしていますので、少々お待ちください…</p>
      //       </body>
      //     </html>
      //   `);
      // }
      // else if (isAppleButNotMac()) {
      // } else {
      // }

      const memberID = sessionStorage.getItem('memberID') ?? '';
      dispatch({
        type: UPDATE_RECEIPT_REQUEST,
        memberId: memberID,
        targetMonth: getTargetMonth,
        paymentDate: getPaymentDate,
        recipientName,
        clauseTitle: clauseTitle || null,
        history,
      });
    }
  };

  useEffect(() => {
    if (isUpdateReceiptLoaded) {
      setIsDisableRecipientName(true);

      // if (updateReceipt.url) {
      //   if (downloadWindow) {
      //     downloadWindow.location.href = updateReceipt.url;
      //     setDownloadWindow(null);
      //   } else {
      //     window.open(updateReceipt.url, '_blank');
      //     window.location.href =updateReceipt.url;
      //   }
      // }
      // if (isGetReceiptDataLoaded && getTargetMonth && getPaymentDate) {
      //   const memberID = sessionStorage.getItem('memberID') ?? '';
      //   dispatch({
      //     type: GET_RECEIPT_REQUEST,
      //     memberId: memberID,
      //     targetMonth: getTargetMonth,
      //     paymentDate: getPaymentDate,
      //     history,
      //   });
      // }
    }
  }, [isUpdateReceiptLoaded]);

  useEffect(() => {
    setErrorMessage(updateReceipt.errorMessage);
    // if (updateReceipt.errorMessage) {
    //   if (downloadWindow) {
    //     downloadWindow.close();
    //     setDownloadWindow(null);
    //   }
    // }
  }, [updateReceipt.errorMessage]);

  useEffect(() => {
    // setErrorMessage('');
    setIsDisableRecipientName(false);
    dispatch({
      type: UPDATE_RECEIPT_INITIAL,
    });
  }, [getTargetMonth, getPaymentDate]);

  return (
    <>
      <MyPageLayout>
        <Layout>
          {/* 領収書取得APIのロードが終わった時 */}
          {isGetReceiptDataLoaded ? (
            <>
              {getReceiptData.result === 0 ? (
                // 領収書取得APIの処理結果が０の場合(領収書なし)
                <>
                  <Title>{FS.F_S_RECEIPT_TOTAL_ZERO_1}</Title>
                </>
              ) : getReceiptData.result === 1 ? (
                // 領収書取得APIの処理結果が１の場合(領収書あり)
                <>
                  {getReceiptData.targetMonthList && getReceiptData.targetMonthList.length > 0 ? (
                    <>
                      <Title>{FS.F_S_RECEIPT_TITLE}</Title>
                      <Row>
                        <ItemLabel>{FS.F_S_RECEIPT_SELECTION_TARGET_MONTH_LABEL}</ItemLabel>

                        <Col>
                          <Select
                            instanceId="receipt-select-target-month"
                            classNamePrefix="receipt-select"
                            className="receipt-selectbox mb-3"
                            placeholder={FS.F_S_RECEIPT_SELECTION_TARGET_MONTH_PLACEHOLDER}
                            options={targetMonthOptionList}
                            // defaultValue={targetMonthOptionList[defaultTargetMonthIndex]}
                            value={targetMonthSelectValue}
                            isSearchable={false}
                            onChange={targetMonthSelectChange}
                          />
                        </Col>
                      </Row>

                      <Row>
                        <ItemLabel>{FS.F_S_RECEIPT_SELECTION_PAYMENT_DATE_LABEL}</ItemLabel>

                        <Col>
                          <Select
                            instanceId="receipt-select-payment-date"
                            classNamePrefix="receipt-select"
                            className="receipt-selectbox mb-3"
                            placeholder={FS.F_S_RECEIPT_SELECTION_PAYMENT_DATE_PLACEHOLDER}
                            options={paymentDateOptionList}
                            // defaultValue={paymentDateOptionList[defaultPaymentDateIndex]}
                            value={paymentDateSelectValue}
                            isSearchable={false}
                            onChange={paymentDateSelectChange}
                          />
                        </Col>
                      </Row>

                      <Row>
                        <ItemLabel className="red-star">
                          {FS.F_S_RECEIPT_INPUT_RECIPIENT_NAME_LABEL}
                          {/* <span style={{ color: 'red' }}>*</span> */}
                        </ItemLabel>

                        <Col>
                          <ReceiptInputGroup className="mb-3">
                            <ReceiptInput
                              type="text"
                              maxLength={36}
                              value={`${recipientName}`}
                              onChange={onChangeRecipientName}
                              disabled={!isGetReceiptLoaded || getReceipt.result > 0 || isDisableRecipientName}
                            />
                            <SuffixText>{FW.F_W_MR}</SuffixText>
                          </ReceiptInputGroup>
                        </Col>
                      </Row>

                      <Row>
                        <ItemLabel>{FS.F_S_RECEIPT_INPUT_CLAUSE_TITLE_LABEL}</ItemLabel>

                        <Col>
                          <ReceiptInputGroup className="mb-3">
                            <ReceiptInput
                              type="text"
                              maxLength={50}
                              value={clauseTitle}
                              onChange={onChangeClauseTitle}
                              disabled={!isGetReceiptLoaded}
                            />
                          </ReceiptInputGroup>
                        </Col>
                      </Row>

                      {errorMessage.length > 0 ? (
                        <ReceiptErrorMessage style={{ textAlign: 'center' }}>
                          {errorMessage.split('\n').map((value, index) => {
                            return (
                              <React.Fragment key={`text-${index.toString()}-${value}`}>
                                <ReceiptErrorMessageText>{value}</ReceiptErrorMessageText>
                                <br />
                              </React.Fragment>
                            );
                          })}
                        </ReceiptErrorMessage>
                      ) : (
                        <></>
                      )}

                      <ReceiptButton
                        onClick={onClickReceiptConfirm}
                        disabled={!isGetReceiptLoaded || !recipientName || isUpdateReceiptLoading}
                      >
                        {isUpdateReceiptLoading ? (
                          <>
                            <ReceiptButtonSpinner animation="border" variant="danger" />
                            {FW.F_W_LOADING}
                          </>
                        ) : (
                          <>{FW.F_W_ISSUE}</>
                        )}
                      </ReceiptButton>

                      <br />
                      <br />
                      <Row>
                        <ItemLabel style={{ width: '4em' }} />
                        <Col>
                          <Explanation>領収書発行後、宛先名は変更できません。</Explanation>
                          <Explanation>領収書の再発行は可能ですが、再発行のスタンプが表示されます。</Explanation>
                          <Explanation>また、宛先名は初回の発行時の設定から変更することはできません。</Explanation>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    <>
                      <Title>{FS.F_S_RECEIPT_TOTAL_ZERO_1}</Title>
                    </>
                  )}
                </>
              ) : getReceiptData.result === 11 ? (
                // 領収書取得APIの処理結果が11の場合
                <>
                  <Title>{FS.F_S_RECEIPT_RESULT_11}</Title>
                </>
              ) : getReceiptData.result === 12 ? (
                // 領収書取得APIの処理結果が12の場合
                <>
                  <Title>{FS.F_S_RECEIPT_RESULT_12}</Title>
                </>
              ) : getReceiptData.result === 13 ? (
                // 領収書取得APIの処理結果が13の場合
                <>
                  <Title>{FS.F_S_RECEIPT_RESULT_13}</Title>
                </>
              ) : getReceiptData.result === 14 ? (
                // 領収書取得APIの処理結果が14の場合
                <>
                  <Title>{FS.F_S_RECEIPT_RESULT_14}</Title>
                </>
              ) : getReceiptData.result === 15 ? (
                // 領収書取得APIの処理結果が15の場合
                <>
                  <Title>{FS.F_S_RECEIPT_RESULT_15}</Title>
                </>
              ) : getReceiptData.result === 99 ? (
                // 領収書取得APIの処理結果が99の場合
                <>
                  <Title>{FS.F_S_RECEIPT_RESULT_99}</Title>
                </>
              ) : (
                // その他の場合
                <>
                  <Title>{FS.F_S_RECEIPT_RESULT_OTHER}</Title>
                </>
              )}
            </>
          ) : (
            <></>
          )}
        </Layout>
      </MyPageLayout>
    </>
  );
};

export default Receipt;
